import { BrowserBarcodeReader, NotFoundException, NotAllowedError } from '@zxing/library';

window.addEventListener('load', function () {
    if (document.querySelector('.manuals-page')) {
        initManualsPage();
    }
});

// ============================================================
// Entry point — routes based on page context + auth methods
// ============================================================

function initManualsPage() {
    // Short URL code-entry page
    if (document.querySelector('.code-entry-page')) {
        initCodeEntryPage();
        return;
    }

    // Manuals page arriving from a successful code entry (auth token in URL)
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get('auth_token');
    if (authToken) {
        verifyTokenAndReveal(authToken);
        return;
    }

    // If the user already has a valid typed-code session, go straight to the manuals list
    if (ajax_global.manuals && ajax_global.manuals.isAuthenticated) {
        showRollupScreen();
        gatherMaterial();
        return;
    }

    // Code entry is only available via the short URL route — always start barcode scanning here
    startScanning();
}

// ============================================================
// Barcode scanning - access via camera
// ============================================================

function showScanningScreen() {
    document.querySelector('.manuals-page-video-overlay').classList.remove('faded');
    document.querySelector('.overlay-instruction').classList.remove('hidden');
    document.querySelector('#landing-content').classList.add('hidden');
    document.querySelector('#scanning-content').classList.remove('hidden');
}
function showLandingScreen() {
    document.querySelector('.manuals-page-video-overlay').classList.add('faded');
    document.querySelector('.overlay-instruction').classList.add('hidden');
    document.querySelector('#landing-content').classList.remove('hidden');
    document.querySelector('#scanning-content').classList.add('hidden');
}

function startScanning() {
    let selectedDeviceId;
    const codeReader = new BrowserBarcodeReader();
    codeReader.listVideoInputDevices()
        .then((videoInputDevices) => {
            const swapButton = document.getElementById('swapButton');
            const videoDevicesCount = videoInputDevices.length;
            let currentDeviceNumber = 0;

            if (videoDevicesCount > 1) {
                swapButton.classList.remove('hidden');

                videoInputDevices.forEach((device, index) => {
                    if (device.label.includes('back') || device.label.includes('rear')) {
                        currentDeviceNumber = index;
                    }
                });
            }

            selectedDeviceId = videoInputDevices[currentDeviceNumber].deviceId;

            // check if camera is allowed. If already allowed, start scanning
            if (selectedDeviceId) {
                showScanningScreen();

                // start scanning
                codeReader.decodeFromVideoDevice(selectedDeviceId, 'barcode-video', (result, err) => {
                    if (result) {
                        // handle result
                        codeReader.reset();
                        handleScanResult(result);
                    }
                    if (err && !(err instanceof NotFoundException)) {
                        console.error(err);
                    }
                });

                swapButton.addEventListener('click', () => {
                    currentDeviceNumber++;
                    if (currentDeviceNumber + 1 > videoDevicesCount) {
                        currentDeviceNumber = 0;
                    }
                    selectedDeviceId = videoInputDevices[currentDeviceNumber].deviceId
                    codeReader.reset();
                    codeReader.decodeFromVideoDevice(selectedDeviceId, 'barcode-video', (result, err) => {
                        if (result) {
                            // handle result
                            codeReader.reset();
                            handleScanResult(result);
                        }
                        if (err && !(err instanceof NotFoundException)) {
                            console.error(err);
                        }
                    });
                });
            }

            document.getElementById('startButton').addEventListener('click', () => {
                showScanningScreen();
                codeReader.decodeFromVideoDevice(selectedDeviceId, 'barcode-video', (result, err) => {
                    if (result) {
                        // handle result
                        codeReader.reset();
                        handleScanResult(result);
                    }
                    if (err && !(err instanceof NotFoundException)) {
                        console.error(err);
                    }
                })
                    .catch((err) => {
                        if (err == "NotAllowedError: Permission denied") {
                            showLandingScreen();
                            alert('Camera access was denied. Please allow camera access to scan barcode.');
                        } else {
                            console.error(err);
                        }
                    });
            })

        })
        .catch((err) => {
            console.error(err)
        })
}

function handleScanResult(result) {
    const pageId = document.querySelector('.manuals-page').dataset.pageId;

    // Simulate a screen flash
    const flash = document.querySelector('.flash-overlay');
    const main = document.querySelector('.main');
    main.classList.add('is-scanned');
    if (flash) {
        flash.classList.add('active');
        setTimeout(() => {
            flash.classList.remove('active');
        }, 500); // duration of the flash
    }
    jQuery.ajax({
        url: ajax_global.url,
        data: {
            action: 'manuals_check_barcode',
            barcode: result.text,
            page_id: pageId,
            nonce: ajax_global.nonce
        },
        type: 'POST',
        success: function (data) {
            if (data.success) {
                main.classList.remove('is-scanned');
                showRollupScreen();
                // Optionally, hide rollup after a delay or when new content is ready
                gatherMaterial();
            } else {
                main.classList.remove('is-scanned');
                if (document.querySelector('.scanning-screen-instruction') && !document.querySelector('.scan-failed')) {
                    document.querySelector('.scanning-screen-instruction').insertAdjacentHTML('beforebegin', "<p class='scan-failed'>" + data.data + "</p>");
                }
                setTimeout(() => {
                    startScanning();
                }, 1500);
            }
        },
        error: function (data) {
            //console.log(data);
        }
    });
}

// ============================================================
// Token verification (arriving on Manuals page from short URL)
// ============================================================

function verifyTokenAndReveal(authToken) {
    const pageId = document.querySelector('.manuals-page').dataset.pageId;

    // Show loading screen immediately
    showRollupScreen();

    // Clean token from the URL bar
    const url = new URL(window.location.href);
    url.searchParams.delete('auth_token');
    window.history.replaceState({}, '', url.toString());

    jQuery.ajax({
        url: ajax_global.url,
        data: {
            action: 'manuals_verify_token',
            token: authToken,
            page_id: pageId,
            nonce: ajax_global.nonce,
        },
        type: 'POST',
        success: function (data) {
            if (data.success) {
                gatherMaterial();
            } else {
                // Token invalid/expired — hide rollup and show the normal auth UI
                document.getElementById('rollupScreen').classList.remove('active');
                initManualsPageFallback();
            }
        },
        error: function () {
            document.getElementById('rollupScreen').classList.remove('active');
            initManualsPageFallback();
        }
    });
}

// Fallback when token verification fails — restart barcode scanning
function initManualsPageFallback() {
    startScanning();
}

// ============================================================
// Short URL code-entry page (/{slug})
// ============================================================

function initCodeEntryPage() {
    const button = document.getElementById('codeSubmitButton');
    const input = document.getElementById('secretCodeInput');
    const errorEl = document.querySelector('.code-entry-error');
    const pageId = document.querySelector('.manuals-page').dataset.pageId;
    const manualsUrl = ajax_global.manuals && ajax_global.manuals.manualsUrl
        ? ajax_global.manuals.manualsUrl
        : '';

    if (!button || !input) return;

    button.addEventListener('click', submitCode);
    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') submitCode();
    });

    function submitCode() {
        const code = input.value.trim();
        if (!code) return;

        button.classList.add('loading');
        if (errorEl) errorEl.style.display = 'none';

        jQuery.ajax({
            url: ajax_global.url,
            data: {
                action: 'manuals_check_code',
                code: code,
                page_id: pageId,
                nonce: ajax_global.nonce,
            },
            type: 'POST',
            success: function (data) {
                button.classList.remove('loading');
                if (data.success) {
                    showRollupScreen();
                    window.location.href = manualsUrl + '?auth_token=' + encodeURIComponent(data.data.token);
                } else {
                    if (errorEl) {
                        errorEl.textContent = data.data;
                        errorEl.style.display = '';
                    }
                    input.focus();
                }
            },
            error: function () {
                button.classList.remove('loading');
            }
        });
    }
}

// ============================================================
// Shared helpers
// ============================================================

function showRollupScreen() {
    const rollup = document.getElementById('rollupScreen');
    if (rollup) {
        rollup.classList.add('active');
    }
    // Optionally, hide after a delay:
    // setTimeout(() => rollup.classList.remove('active'), 2000);
}

function gatherMaterial() {
    const pageId = document.querySelector('.manuals-page').dataset.pageId;
    jQuery.ajax({
        url: ajax_global.url,
        data: {
            action: 'manuals_gather_material',
            page_id: pageId,
            nonce: ajax_global.nonce
        },
        type: 'POST',
        success: function (data) {
            if (data.success) {
                document.querySelector('.manuals-page').innerHTML = data.data;
                document.querySelector('.manuals-page').classList.add('list-view')
            } else {
                document.querySelector('.rollup-screen').classList.remove('active');
                document.querySelector('.manuals-page-video-overlay').classList.add('hidden');
                document.querySelector('#scanning-content').innerHTML = data.data;
            }
        },
        error: function (data) {
            // console.log(data);
        }
    });
}

// ============================================================
// Desktop menu keyboard accessibility
// ============================================================
const parentMenuItems = document.querySelectorAll('.mainNav li.menu-item-has-children > a');
let returnFocusTo;
parentMenuItems.forEach(item => {
    if (window.innerWidth < 1000) return;

    // if we hit enter or spacebar, open the submenu and focus on the first item
    item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            returnFocusTo = this;
            const submenu = this.nextElementSibling;
            if (submenu && submenu.classList.contains('sub-menu')) {
                submenu.style.display = 'block';
                const firstSubItem = submenu.querySelector('li a');
                if (firstSubItem) {
                    firstSubItem.focus();
                }
            }
        }
    });

    // close and return focus on esc
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            const openSubmenus = document.querySelectorAll('.sub-menu');
            openSubmenus.forEach(submenu => {
                submenu.removeAttribute('style');
            });
            if (returnFocusTo) {
                returnFocusTo.focus();
            }
        }
    });
});
